/* istanbul ignore file */
import routes from '../components/routes/routes';

export const headerEnv = () => {
  const env = window?.headerLoaderEnv ?? '';
  return env;
};
export const isHeaderEnvProduction = () => headerEnv() === 'prod';
// Captcha Site Key
export const CAPTCHA_KEY = '6LdM9yIUAAAAAO1HFvK9xABFs4miCEvQRi-oklfx';
export const GOOGLE_RECAPTCHA_ENTERPRISE_KEY = isHeaderEnvProduction()
  ? '6LeQ9cMcAAAAAFZHO6v3Hmi-3ljppHJA6RqkC97Q'
  : '6LcN2JMcAAAAAGbWVktzqeWfWLNXFOXCuvQ3e6r9';

// Local Storage Secret for First Name Storage
export const LOCAL_STORAGE_SECRET = 'BletchleyPark';

// Acquisition offer discount
export const creditCardDiscount = '20%';

export const MAX_MOBILE_WIDTH = 991;
export const MAX_MOBILE_ONLY_WIDTH = 767;
const LOYALTY_BRANDING_INSIDER = 'insiderConfig';

export const SOURCE_AND_DEVICE_TYPE = {
  MOBILE_CHECKOUT: 'MOBILE_CHECKOUT',
  MOBILE_ACCOUNT: 'MOBILE_ACCOUNT',
  MOBILE_PRODUCTPAGE: 'MOBILE_PRODUCTPAGE',
  MOBILE_HOME: 'MOBILE_HOME',
  MOBILE_REWARDS: 'MOBILE_REWARDS',
  MOBILE_BAG: 'MOBILE_BAG',
  WEB_CHECKOUT: 'WEB_CHECKOUT',
  WEB_ACCOUNT: 'WEB_ACCOUNT',
  WEB_PRODUCTPAGE: 'WEB_PRODUCTPAGE',
  WEB_HOME: 'WEB_HOME',
  WEB_REWARDS: 'WEB_REWARDS',
  WEB_BAG: 'WEB_BAG',
};

export const LOYALTY_BRANDING_CONFIGS = {
  [LOYALTY_BRANDING_INSIDER]: {
    hoverableSlideOutModal: {
      loggedOut: {
        aListIconClassName: 'insiderClass',
        availableRewardsText: 'in available rewards',
        containerClassName: 'insiderLogo',
        creditCardIcon: 'insiderCard',
        creditCardName: 'Have the Express Credit Card?',
        creditCardTitle: 'Have the Express Credit Card?',
        firstBtnPath: routes.signUp.path,
        firstBtnTxt: 'Join for Free',
        firstPhrase: 'Welcome to a whole new world of',
        headerContainerClassName: 'insiderCC',
        icon: 'expressInsiderLogo',
        iconCard: 'insiderCard',
        linkClassName: 'linkInsider',
        meterColor: '#000000',
        saveMoneyText: `Remember you get an extra 5%** off every time you use it.`,
        secondBtnPath: routes.login.path,
        secondBtnTxt: 'Sign In',
        secondPhrase: 'rewards and access.',
        viewAccountText: 'View your account or make a payment.',
      },
      isInsider: true,
    },
    toolTip: {
      prefixText: 'You have',
      suffixText: 'in Express Cash available',
    },
  },
};
export const LOYALTY_BRANDING_CONFIG = LOYALTY_BRANDING_CONFIGS.insiderConfig;

export const LOYALTY_NEW_TIERS_POINTS = {
  insider: 2500,
  influencer: 10000,
  alist: 0,
  vip: 0,
};

export const TIERS_BENEFITS_LIST = {
  earnRewards: { icon: 'earnRewards', name: 'Earn Express Cash' },
  birthdayGift: { icon: 'birthdayGift', name: 'Birthday Gifts' },
  receiptlessReturns: {
    icon: 'receiptlessReturns',
    name: 'Receiptless Returns',
  },
  earlyAccess: { icon: 'earlyAccess', name: 'Early Access' },
  fasterExpressCash: { icon: 'fasterRewardsIcon', name: 'Faster Express Cash' },
  freeShippigAndReturns: {
    icon: 'freeShipping',
    name: 'Free Shipping & Returns',
  },
};
export const TIER_STATIC_CONFIGS = {
  vip: {
    tierDesktopIcon: 'loyaltyVIPLogoBlack',
    tierMobileIcon: 'loyaltyVIPLogoWhite',
    tierBenefits: [
      TIERS_BENEFITS_LIST.earnRewards,
      TIERS_BENEFITS_LIST.birthdayGift,
      TIERS_BENEFITS_LIST.receiptlessReturns,
      TIERS_BENEFITS_LIST.earlyAccess,
    ],
    isECCHolderTierBenefits: [
      TIERS_BENEFITS_LIST.fasterExpressCash,
      TIERS_BENEFITS_LIST.birthdayGift,
      TIERS_BENEFITS_LIST.freeShippigAndReturns,
      TIERS_BENEFITS_LIST.earlyAccess,
    ],
  },
  alist: {
    tierDesktopIcon: 'loyaltyAListLogoBlack',
    tierMobileIcon: 'loyaltyAListLogoWhite',
    tierBenefits: [
      TIERS_BENEFITS_LIST.earnRewards,
      TIERS_BENEFITS_LIST.birthdayGift,
      TIERS_BENEFITS_LIST.receiptlessReturns,
      TIERS_BENEFITS_LIST.earlyAccess,
    ],
    isECCHolderTierBenefits: [
      TIERS_BENEFITS_LIST.fasterExpressCash,
      TIERS_BENEFITS_LIST.birthdayGift,
      TIERS_BENEFITS_LIST.freeShippigAndReturns,
      TIERS_BENEFITS_LIST.earlyAccess,
    ],
  },
  insider: {
    tierDesktopIcon: 'loyaltyInsiderLogoBlack',
    tierMobileIcon: 'loyaltyInsiderLogoWhite',
    tierBenefits: [
      TIERS_BENEFITS_LIST.earnRewards,
      TIERS_BENEFITS_LIST.birthdayGift,
      TIERS_BENEFITS_LIST.receiptlessReturns,
      TIERS_BENEFITS_LIST.earlyAccess,
    ],
    nextTier: { name: 'Influencer', key: 'influencer' },
  },
  influencer: {
    tierDesktopIcon: 'loyaltyInfluencerLogoBlack',
    tierMobileIcon: 'loyaltyInfluencerLogoWhite',
    tierBenefits: [
      TIERS_BENEFITS_LIST.earnRewards,
      TIERS_BENEFITS_LIST.birthdayGift,
      TIERS_BENEFITS_LIST.receiptlessReturns,
      TIERS_BENEFITS_LIST.earlyAccess,
    ],
    isECCHolderTierBenefits: [
      TIERS_BENEFITS_LIST.fasterExpressCash,
      TIERS_BENEFITS_LIST.birthdayGift,
      TIERS_BENEFITS_LIST.freeShippigAndReturns,
      TIERS_BENEFITS_LIST.earlyAccess,
    ],
    nextTier: { name: 'A-List', key: 'alist' },
  },
};

export const DEFAULT_TIER = 'insider';

export const AUTOCOMPLETE_DATASET = 'cloud-retail';

// Login container constants
export const LOGIN_FORM = 'logingForm';
export const FORGOT_PASSWORD_FORM = 'forgotPasswordForm';

export default {
  LOYALTY_BRANDING_CONFIG,
  LOCAL_STORAGE_SECRET,
  TIER_STATIC_CONFIGS,
  DEFAULT_TIER,
};
